import classNames from "classnames";
import { LucideIcon } from "lucide-react";
import * as React from "react";
import styled from "styled-components";

interface Props {
  title?: string;
  slim?: boolean;
  children?: React.ReactNode;
}

function HeaderRoot({ title, slim, children }: Props) {
  return (
    <Container className={slim ? "slim" : ""}>
      {title && <Title>{title}</Title>}
      <Actions>{children}</Actions>
    </Container>
  );
}

const Container = styled.header`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  margin: 20px 0 20px 10px;
  &.slim {
    margin: 10px 0 10px 10px;
  }
  @media (min-width: 600px) {
    margin-top: 0;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
  padding: 0;
  margin: 0;
  flex-grow: 1;
  .slim & {
    font-size: 20px;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

const ButtonRoot = styled.button`
  padding: 5px 15px 5px 10px;
  white-space: nowrap;
  cursor: pointer;
  background: var(--theme-color-primary);
  border: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  color: var(--text-light-color);
  font-size: 14px;
  &:hover {
    background: #2b3564;
  }
  &.secondary {
    color: var(--text-primary-color);
    background: var(--box-color);
    &:hover {
      background: var(--box-color-hover);
    }
  }
  &.slim {
    padding: 3px 10px 3px 8px;
  }
`;

const ButtonIcon = styled.div`
  margin-right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.75;
`;

interface ButtonProps {
  children: React.ReactNode;
  icon?: LucideIcon;
  secondary?: boolean;
  slim?: boolean;
  onClick: () => void;
}

function Button({ children, onClick, slim, icon: Icon, secondary }: ButtonProps) {
  return (
    <ButtonRoot onClick={onClick} className={classNames({ secondary, slim })}>
      {Icon && (
        <ButtonIcon>
          <Icon size={14} />
        </ButtonIcon>
      )}
      {children}
    </ButtonRoot>
  );
}

export const Header = Object.assign(HeaderRoot, { Button });
